import React from "react";
import PropTypes from "prop-types";
import { getTrueClasses } from "../../../helpers";
import "./index.scss";

const RecaptchaWrapper = ({ children, customClass }) => (
  <div className={getTrueClasses("RecaptchaWrapper", customClass)}>
    {children}
  </div>
);

RecaptchaWrapper.propTypes = {
  children: PropTypes.any.isRequired,
  customClass: PropTypes.string,
};

export default RecaptchaWrapper;
